'use client';
import styled from 'styled-components';

import { Spacers } from '@styles/theme';

export const ColumnContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const RowContainerGap = styled.div`
  display: flex;
  gap: ${Spacers.XS}rem;
  color: ${({ theme }) => theme.colors.typographyBodyLight};
`;

export const SectionBigGap = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacers.XXL}rem;
`;

export const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacers.XS}rem;
`;